module.exports = __webpack_public_path__ + "img/ic_64_logo.dabd3bf3.svg";